/**
 * URL Utilities - Helper funkcije za generisanje URL-ova objava
 */

import { getNoticeSlugFromRecord } from './noticeSlug';

/**
 * Konvertuje tip objave u slug za URL
 * @param {string} type - Tip objave (REPORT, ANNOUNCEMENT, itd.)
 * @returns {string} Slug za URL (npr. "izvestaji", "konsultacije")
 */
export const getTypeSlug = (type) => {
  const typeSlugs = {
    REPORT: 'izvestaji',
    CONSULTATION: 'konsultacije',
    NOTICE: 'objave',
  };
  return typeSlugs[type] || 'izvestaji';
};

/**
 * Konvertuje slug u tip objave
 * @param {string} slug - Slug iz URL-a
 * @returns {string|null} Tip objave (REPORT, CONSULTATION)
 */
export const getTypeFromSlug = (slug) => {
  const slugToType = {
    izvestaji: 'REPORT',
    konsultacije: 'CONSULTATION',
    objave: 'NOTICE',
  };
  return slugToType[slug] || null;
};

/**
 * Vraća srpski naziv tipa objave
 * @param {string} type - Tip objave
 * @returns {string} Srpski naziv tipa
 */
export const getTypeLabel = (type) => {
  const typeLabels = {
    REPORT: 'Извештај',
    NOTICE: 'Објава',
    ANNOUNCEMENT: 'Објава',
    CONSULTATION: 'Консултације',
    'OBLIGATION': 'Обавеза',
    'OTHER': 'Остало',
  };
  return typeLabels[type] || type;
};

/**
 * Generiše URL za objavu na osnovu tipa i sluga
 * @param {Object} notice - Objava objekat
 * @param {string} notice.type - Tip objave
 * @param {string} notice.slug - Slug objave
 * @returns {string} URL putanja (npr. "/objave/moj-slug")
 */
export const getNoticeUrl = (notice) => {
  const slug = getNoticeSlugFromRecord(notice);
  if (!slug) {
    return '/objave';
  }
  return `/objave/${slug}`;
};

/**
 * Generiše URL za listing objava po tipu
 * @param {string} type - Tip objave
 * @returns {string} URL putanja (npr. "/objave/izvestaji")
 */
export const getNoticeTypeUrl = (type) => {
  if (!type) {
    return '/objave';
  }
  const typeSlug = getTypeSlug(type);
  return `/objave/kategorija/${typeSlug}`;
};

/**
 * Generiše URL za listing svih objava
 * @returns {string} URL putanja "/objave"
 */
export const getNoticesListUrl = () => {
  return '/objave';
};

/**
 * Javni URL objave sa deep link-om na PDF dokument u konsultaciji.
 * @param {string|Object} noticeOrSlug - Slug ili notice/seo zapis
 * @param {string} documentId - ID dokumenta (related_entity_id na obaveštenju)
 * @returns {string}
 */
export const getNoticeConsultationDocumentUrl = (noticeOrSlug, documentId) => {
  const slug =
    typeof noticeOrSlug === 'string'
      ? noticeOrSlug.trim()
      : getNoticeSlugFromRecord(noticeOrSlug);
  if (!slug || documentId == null || documentId === '') {
    return getNoticesListUrl();
  }
  return `/objave/${slug}?document=${encodeURIComponent(String(documentId))}`;
};

